var divider_viewer_default = {
  "divider-container": "FIVQR",
  "divider-container--double": "cpBus",
  "divider": "_500vS",
  "divider--single": "Q2oht",
  "divider--double": "ZSVkg",
  "divider--dashed": "bQPkC",
  "divider--dotted": "_5ERMA",
  "divider--small": "V1kzc",
  "divider--medium": "wuOi8",
  "divider--large": "wPeUD",
  "divider--left": "pQyoo",
  "divider--center": "iS2PI",
  "divider--right": "Gno7v",
  "svgFixerContainer": "M1PIU",
  "emptyChar": "rPxVK"
};
export {
  divider_viewer_default as default
};
//# sourceMappingURL=divider-viewer-scss.js.map
